import React, { useState } from 'react'
import IndSectionTabs from '../../components/IndSectionTabs'

// ... existing imports ...

const tabData = [
   {
      id: '01ete',
      title: '01. Custom e-Government Portal Development',
      intitle: 'Custom e-Government Portal Development',
      icon: '/assets/svg/industries/gov-public/01.svg',
      content:
         'We develop secure e-government portals that streamline public services, enhance citizen engagement, and digitize government operations, ensuring efficient service delivery. Our solutions include centralized service dashboards, document management, and automated workflows. We provide e-signatures, digital identity verification, and secure payment processing. With multi-language capabilities, real-time tracking of services, and self-service interfaces, we assist governments in providing quicker, more transparent, and citizen-centric services.',
   },
   {
      id: '02ete',
      title: '02. Public Administration & Resource Management Systems',
      intitle: 'Public Administration & Resource Management Systems',
      icon: '/assets/svg/industries/gov-public/02.svg',
      content:
         'Our public sector resource management platforms enable efficient handling of government operations, including budget management, HR, and resource allocation. We develop integrated systems for financial planning, procurement, and personnel management. Automated payroll, time management, and compliance monitoring are our offerings. With audit trails, predictive analytics, and real-time reporting, we enable government agencies to make better decision-making and optimum use of resources.',
   },
   {
      id: '03ete',
      title: '03. Citizen Service Applications & Portals',
      intitle: 'Citizen Service Applications & Portals',
      icon: '/assets/svg/industries/gov-public/03.svg',
      content:
         'We build user-centric citizen service apps that allow residents to access government services, pay bills, and submit requests through secure digital platforms. Our solutions offer service directories, online form submissions, and payment integrations. We implement push notifications for service updates, appointment scheduling, and request tracking. With multi-device accessibility, self-service options, and real-time support, we enhance citizen engagement and satisfaction.',
   },
   {
      id: '04ete',
      title: '04. Secure Data Management & Storage Solutions',
      intitle: 'Secure Data Management & Storage Solutions',
      icon: '/assets/svg/industries/gov-public/04.svg',
      content:
         'Our data management platforms provide secure storage, processing, and retrieval of sensitive government information, in accordance with compliance and regulatory requirements. We use encrypted databases, access control, and automated backups. Our solutions include data classification, secure sharing, and audit logging. Through real-time monitoring, permission-based rights, and GDPR conformity, we enable governments to secure sensitive data and maintain data integrity.',
   },
   {
      id: '05ete',
      title: '05. Public Safety & Law Enforcement Software',
      intitle: 'Public Safety & Law Enforcement Software',
      icon: '/assets/svg/industries/gov-public/05.svg',
      content:
         'We create law enforcement applications that streamline incident reporting, case management, and real-time data sharing, enhancing public safety operations. Our solutions include automated case filing, evidence management, and criminal record databases. We apply GPS monitoring, predictive analysis, and AI-based crime pattern recognition. Through mobile access, real-time notifications, and unified reporting, we facilitate improved response times and operational effectiveness for law enforcement agencies.',
   },
   {
      id: '06ete',
      title: '06. Smart City & IoT Solutions for Public Infrastructure',
      intitle: 'Smart City & IoT Solutions for Public Infrastructure',
      icon: '/assets/svg/industries/gov-public/06.svg',
      content:
         'Our IoT-powered solutions support smart city initiatives, including traffic management, waste management, and energy monitoring, promoting urban efficiency. We develop sensor-based platforms for real-time data collection and analytics. Our applications range from smart traffic management, automated street lighting, and waste tracking to smart solutions. With AI-based insights, predictive maintenance, and citizen applications, we enable cities to become more sustainable, lower their costs, and enhance the quality of life.',
   },
];

function IndSectionTwo() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="text-center tech_title section_heading_title mb-2">
               Innovative Government & Public Sector Software Development Solutions
            </h2>
            <p className="section_desc end-to-end-section mb-xl-0 mb-4">
               Provide state-of-the-art software solutions to public institutions and government agencies to improve productivity, openness, and citizen participation.  Our offerings guarantee safe, expandable, and intuitive systems for efficient public service provision.
            </p>
            <IndSectionTabs tabData={tabData} />
         </div>
      </section>
   )
}

export default IndSectionTwo
